export function getDataByPageAndPosition(data, pageName, position) {
  return data.filter(item => item.pageName === pageName && item.pagePosition === position) || [];
}